<template>
  <div id="income-list" class="carrier-list-data">
    <div class="summary din" @click="$emit('close')">
      <div class="date">{{formatDate(date.toString())}}</div>
      <div>当日共PK{{ pkAnchorCount }}人，累计时长{{ totalDuration }}</div>
      <van-icon class="close-btn" name="cross" />
    </div>
    <a :href="item.link" v-for="(item, index) of tableData" :key="index" class="item-default">
      <div class="commodity-sort">{{ index + 1 }}</div>
      <div class="item-icon">
        <img :src="item.avatar" alt="达人" style="border-radius: 100%"/>
      </div>
      <div class="center-anchor-goods">
        <div class="item-name flex align">
          {{ item.nickName }}
          <span class="item-icon-isOnList" v-if="item.isOnList">在榜</span>
        </div>
        <div style="margin-top: 8px;font-size: 0.2rem;font-weight: 400;color: #868E9B;">{{ item.fansCount }}</div>
      </div>
      <object class="flex-all">
        <div class="data-for-detail">
          <div class="data-title">开始PK时间</div>
          <div class="data-number data-number-red">{{ item.timeFrame }}</div>
          <div class="data-title data-title-sec">PK时长</div>
          <div class="data-number">{{ item.duration }}</div>
        </div>
      </object>
    </a>
  </div>
</template>

<script>
import {dateLongDuration} from "@/plugins/helper";
import moment from "moment";

export default {
  props: { liveInfo: Object },
  data() {
    return {
      date:'', // 时间
      pkAnchorCount:0, // pk人数
      tableListDataApi: [],
      defaultAnchorIcon: require('static/images/default-anchor-icon.png')
    }
  },
  watch: {
    liveInfo:{
      immediate:true,
      async handler(value){
        this.tableListDataApi = []
        this.date = value.date
        this.pkAnchorCount = value.pkAnchorCount
        await this.getPkData()
      }
    }
  },
  methods: {
    async getPkData(){
      if(!this.isProVip) return;
      this.$showLoading()
      const res = await this.$api.get(`/v2/anchor/${this.$route.params.id}/liveStreamPK`,{params: { timeMode:14,time:this.date }}).catch( _=> ({}))
      this.tableListDataApi = res.data || []
      this.$hideLoading()
    },
    formatDate(date, template = 'YYYY-MM-DD') {
      return moment(date).format(template)
    },
  },
  computed:{
    isProVip: (_this = this) => ( _this.$store.state.userLevel && _this.$store.state.userLevel <= 95 ),
    totalDuration(){ // 直播时长
      const durationCom = this.tableListDataApi.reduce( (total, ele) => ( total + ele.duration ),0 )
      return isNaN(durationCom) ? '-' : dateLongDuration(durationCom) // 累计时长
    },
    tableData: (_this = this) => ( _this.$_.sortBy(_this.tableListDataApi, (e) => ( e.startTime )).map( ele => ({
      timeFrame: ele.startTime ? moment.unix(ele.startTime).format('hh:mm:ss') :'-', //开始时间
      duration: ele.duration ? dateLongDuration(ele.duration) : '-',// 时长
      nickName: ele?.anchor?.name || '未知主播' ,// 达人名称
      isOnList: ele?.isOnList === 1, // 是否在榜
      fansCount: ele?.anchor?.fans ? _this.$retainWan(ele.anchor.fans) + '粉丝' : '-',// 粉丝数目
      avatar: ele?.anchor?.avatar?  ele?.anchor?.avatar : _this.defaultAnchorIcon, //头像
      link: ele?.anchor?.id ? `/anchor/${ele?.anchor?.id}?banner=2` : '' , //链接
    })) || [])
  }
}
</script>

<style lang="less" scoped>
@import './common.less';
.carrier-list-data{
  &__table-row{
    background: #ffffff;
  }
}
</style>
